import { render, staticRenderFns } from "./PermissionDeleteModal.vue?vue&type=template&id=147dd4b2&scoped=true&"
import script from "./PermissionDeleteModal.vue?vue&type=script&lang=js&"
export * from "./PermissionDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147dd4b2",
  null
  
)

export default component.exports